module.exports = __webpack_public_path__ + "img/List.9f781765.svg";